// extracted by mini-css-extract-plugin
export default {"tag_nav_bar":"tagBar_tag_nav_bar__we1y8","tag_bar":"tagBar_tag_bar__Ws7lW"};